import React from 'react';
import "./styles/userType.css";
import { ReactComponent as BusinessOwnerIcon } from '../../../images/business_owner.svg';
import { ReactComponent as MarketingAgencyIcon } from '../../../images/marketing_agency.svg';

const UserTypeStep = ({ formData, updateFormData }) => {
  return (
    <div className="step-content user-type-step">
      <h2>What type of user are you?</h2>
      <div className="user-type-cards">
        <div
          className={`user-type-card ${formData.userType === 'business_owner' ? 'selected' : ''}`}
          onClick={() => updateFormData('userType', 'business_owner')}
        >
          <div className="icon-wrapper">
            <BusinessOwnerIcon />
          </div>
          <div className="text-card-wrapper">
            <h4>Business Owner</h4>
            <p>You own a business and want to gain valuable insights from your customer reviews to improve your service and grow your business.</p>
          </div>
        </div>
        <div
          className={`user-type-card ${formData.userType === 'agency_manager' ? 'selected' : ''}`}
          onClick={() => updateFormData('userType', 'agency_manager')}
        >
          <div className="icon-wrapper">
            <MarketingAgencyIcon />
          </div>
          <div className="text-card-wrapper">
            <h4>Marketing Agency</h4>
            <p>You manage multiple businesses and want to efficiently track, analyze, and improve their online reputation across different platforms.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserTypeStep;
